module.exports = __webpack_public_path__ + "img/transition-intro-desktop.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/verify/transition-intro-desktop.jpg
// module id = 258
// module chunks = 245 247